import type { Provider } from "../types";
import { ProviderBadge } from "./ProviderBadge";

interface ProviderSelectProps {
  providers: Provider[];
  onSelect: (provider: Provider) => void;
}

export function ProviderSelect({ providers, onSelect }: ProviderSelectProps) {
  return (
    <div>
      <h1 className="text-base font-semibold text-gray-900">Select Your Provider</h1>

      <div className="mt-5 space-y-3">
        {providers.map((provider) => (
          <button
            key={provider.id}
            type="button"
            onClick={() => onSelect(provider)}
            className="w-full flex items-center gap-3 border border-gray-300 px-4 py-3 text-left hover:border-gray-500 hover:bg-gray-50"
          >
            <ProviderBadge provider={provider} size="lg" />
            <span className="text-sm font-medium text-gray-900">{provider.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
